/**
 * APP CONFIG 에서 사용되는 공통 Vuex store
 */
import _ from "lodash";
export default {
  namespaced: true,
  state: {
    snackbars: [], // 스낵바 글로벌 사용을 위해 설정
    messageBox: {},
    prevFilter: null, // 이전화면 필 검색 옵션,
    commCodes: [],
  },
  mutations: {
    /**
     * 스낵바(SNACKBAR) 표시 설정 mutation
     * @param {*} state
     * @param {*} snackbar
     */
    SET_SNACKBAR(state, snackbar) {
      state.snackbars = state.snackbars.filter((s) => {
        return s.show == true;
      });
      // state.snackbars = state.snackbars.concat(snackbar);
      state.snackbars.push(snackbar);
    },
    /**
     * 검색조건 저장
     * @param {*} state
     * @param {*} prevFilter
     */
    SET_PREV_FILTERS(state, prevFilter) {
      state.prevFilter = prevFilter;
    },

    CLEAR_SNACKBAR(state) {
      state.snackbars = state.snackbars.filter((s) => {
        return s.show == true;
      });
    },
    /**
     * 메시지 박스 표시 설정 mutation
     * @param {*} state
     * @param {*} options
     */
    OPEN_MESSAGE_BOX(state, options) {
      state.messageBox = options;
      // return new Promise((resolve, reject) => {
      //   this.resolve = resolve;
      //   this.reject = reject;
      // });
    },
    CLOSE_MESSAGE_BOX(state) {
      state.messageBox.dialog = false;
    },
    SET_COMMCODES(state, commCodes) {
      state.commCodes = _.unionBy(state.commCodes, commCodes, "codeId");
    }
  },
  getters: {
    getPrevFilter: (state) => {
      return state.prevFilter;
    },
  },
  actions: {
    /*
     * notify(스낵바) 표시 하기 action
     * @param {*} param0
     * @param {*} snackbar
     */
    setSnackbar({ commit }, snackbar) {
      // let sb = snackbar;
      let opt = Object.assign({}, snackbar);
      commit("SET_SNACKBAR", opt);
    },

    setPrevFilter({ commit }, prevFilter) {
      commit("SET_PREV_FILTERS", prevFilter);
    },
    /*
     * notify(스낵바) 표시 하기 action
     * @param {*} param0
     * @param {*} snackbar
     */
    openMessageBox({ commit }, options) {
      commit("OPEN_MESSAGE_BOX", options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    closeMessageBox({ commit }, flag) {
      this.resolve(flag);
      commit("CLOSE_MESSAGE_BOX", flag);
    },
  },
};
